import { deepGet } from '../other/other';

/**
 * å­ç¬¦ä¸²æ ¼å¼å
 * ```
 * format('this is ${name}', { name: 'asdf' })
 * // output: this is asdf
 * format('this is ${user.name}', { user: { name: 'asdf' } }, true)
 * // output: this is asdf
 * ```
 */
export function format(str: string, obj: {}, needDeepGet = false): string {
  return (str || '').replace(
    /\${([^}]+)}/g,
    (work: string, key: string) =>
      needDeepGet
        ? deepGet(obj, key.split('.'), '')
        : (obj || {})[key] || '',
  );
}

/**
 * è½¬åæRMBåå­ç¬¦ä¸²
 * @param digits å½æ°å­ç±»åæ¶ï¼åè®¸æå®å°æ°ç¹åæ°å­çä¸ªæ°ï¼é»è®¤2ä½å°æ°
 */
export function yuan(value: any, digits: number = 2): string {
  if (typeof value === 'number') { value = value.toFixed(digits); }
  return `&yen ${value}`;
}
